// extracted by mini-css-extract-plugin
module.exports = {"dealInfoContainer":"_2Sv7Sou-","containerTitle":"_27GnZPt8","salesBlock":"_1ZpSrQ6F","rowInputs":"_2yAv1Aq7","columnInputs":"_1HNunsrF","inputsContainer":"_65hSLmlH","companyContainer":"F-76eIoo","companyLogo":"_2Sl1D5Aq","companyDetails":"_3Zm4mfVo","companyName":"_1_gfU63q","companyPosition":"_3dGWQ5Cz","companyYears":"UMhXWcgP","salesPeriodContainer":"_1RNUQSFi","salesPeriodTitle":"_1oAWRVs_","salesPeriodMonths":"_26-Tpguc"};
    if(module.hot) {
      // 1746735793612
      var cssReload = require("!../../../../../../../node_modules/css-hot-loader/hotModuleReplacement.js")(module.id, {"fileMap":"{fileName}"});
      module.hot.dispose(cssReload);
      module.hot.accept(undefined, cssReload);;
    }
  